<template>
  <div>
    <header class="base__header">
      <h5 class="text-nowrap">База знаний</h5>
    </header>
    <main>
      <b-card class="base__block">
        <div class="base__block__header">
          <p class="base__block__header-title">Управление доступом</p>
        </div>
        <div class="d-flex flex-wrap mar-top-30 mar-bot-10">
          <div
            class="base__block__user d-flex align-items-center"
            v-for="user in filteredUserList()"
            :key="user.id"
          >
            <img
              :src="$IMAGE(resolveUser(user.email).image)"
              @error="$avatarError"
            />
            <p>{{ userName(user.email) }}</p>
            <span v-b-modal.delete @click="getDataForRemove(user.email, 'user')"
              >Удалить</span
            >
          </div>
        </div>
        <b-button
          pill
          class="btn-lg btn-theme-inverse mar-bot-15 mar-top-15"
          v-b-modal.get-access
          >Дать доступ</b-button
        >
      </b-card>
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <card
            :list="categories"
            title="Управление категориями"
            button="Добавить категорию"
            modal="category"
            @getData="getDataItem"
            @removeData="getDataForRemove"
          />
        </div>
        <div class="col-md-6 col-xs-12">
          <card
            :list="subCategories"
            title="Управление подкатегориями"
            button="Добавить подкатегорию"
            modal="subcategory"
            @getData="getDataItem"
            @removeData="getDataForRemove"
          />
        </div>
      </div>
      <b-modal
        id="get-access"
        centered
        hide-header
        hide-footer
        content-class="p-4"
        @hidden="reset"
      >
        <h4 class="mar-bot-20">
          Дать доступ
        </h4>
        <v-select
          class="custom-style-select mar-bot-20"
          :options="filteredUserName"
          label="text"
          v-model="selectedUser"
        ></v-select>
        <b-button class="btn-theme mar-bot-10 mar-right-10" @click="getAccess"
          >Дать доступ</b-button
        >
        <b-button
          class="btn-theme-inverse mar-bot-10"
          @click="$bvModal.hide('get-access')"
          >Закрыть</b-button
        >
      </b-modal>
      <b-modal
        id="new-category"
        centered
        hide-header
        hide-footer
        @hidden="reset"
        content-class="p-4"
      >
        <h4 class="mar-bot-20">
          Новая категория
        </h4>
        <b-form-input
          type="text"
          name="Категория"
          class="mar-bot-10"
          v-model="selectedItem"
        ></b-form-input>
        <div class="mar-bot-20">
          <div class="theme-checkbox ">
            <input type="checkbox" id="attach" v-model="attach" />
            <label for="attach">Прикрепить</label>
          </div>
        </div>
        <b-button
          class="btn-theme mar-bot-10 mar-right-10"
          @click="addCategory()"
          >Добавить</b-button
        >
        <b-button
          class="btn-theme-inverse mar-bot-10"
          @click="$bvModal.hide('new-category')"
          >Закрыть</b-button
        >
      </b-modal>
      <b-modal
        id="new-subcategory"
        centered
        hide-header
        hide-footer
        @hidden="reset"
        content-class="p-4"
      >
        <h4 class="mar-bot-20">
          Новая подкатегория
        </h4>
        <b-form-input
          type="text"
          name="Категория"
          class="mar-bot-20"
          v-model="selectedItem"
        ></b-form-input>
        <b-button
          class="btn-theme mar-bot-10 mar-right-10"
          @click="addSubCategory"
          >Добавить</b-button
        >
        <b-button
          class="btn-theme-inverse mar-bot-10"
          @click="$bvModal.hide('new-subcategory')"
          >Закрыть</b-button
        >
      </b-modal>
      <b-modal
        id="edit-category"
        centered
        hide-header
        hide-footer
        content-class="p-4"
      >
        <h4 class="mar-bot-20">
          Категория
        </h4>
        <v-select
          class="custom-style-select mar-bot-10"
          :options="typesCategories"
          label="text"
          v-model="selectedItem"
        ></v-select>
        <div class="mar-bot-20">
          <div class="theme-checkbox ">
            <input type="checkbox" id="attach" v-model="attach" />
            <label for="attach">Прикрепить</label>
          </div>
        </div>
        <b-button
          class="btn-theme mar-bot-10 mar-right-10"
          @click="editCategory()"
          :disabled="!selectedItem"
          >Сохранить</b-button
        >
        <b-button
          class="btn-theme-inverse mar-bot-10"
          @click="reset('edit-category')"
          >Закрыть</b-button
        >
      </b-modal>
      <b-modal
        id="edit-subcategory"
        content-class="p-4"
        centered
        hide-header
        hide-footer
      >
        <h4 class="mar-bot-20">
          Подкатегория
        </h4>
        <v-select
          class="custom-style-select mar-bot-20"
          :options="typesSubCategories"
          label="text"
          v-model="selectedItem"
        ></v-select>
        <b-button
          class="btn-theme mar-bot-10 mar-right-10"
          @click="editSubCategory()"
          :disabled="!selectedItem"
          >Сохранить</b-button
        >
        <b-button
          class="btn-theme-inverse mar-bot-10"
          @click="reset('edit-subcategory')"
          >Закрыть</b-button
        >
      </b-modal>
      <b-modal
        id="delete"
        centered
        size="sm"
        hide-header
        hide-footer
        content-class="p-4"
      >
        <h4 class="mar-bot-30">
          Точно удалить?
        </h4>
        <b-button-group>
          <b-button class="btn-danger mar-bot-10 mar-right-10" @click="remove()"
            >Удалить</b-button
          >
          <b-button
            class="btn-theme-inverse mar-bot-10 mar-left-10"
            @click="reset('delete')"
            >Закрыть</b-button
          >
        </b-button-group>
      </b-modal>
    </main>
  </div>
</template>
<script>
import Card from "@/components/base/CardSettings";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  components: {
    Card
  },
  data() {
    return {
      attach: true,
      selectedUser: null,
      itemId: null,
      titleItem: null,
      selectedItem: null,
      filteredUserName: []
    };
  },
  async created() {
    await this.loadCategories();
    await this.loadSubCategories();
    await this.getUsersList();
  },
  computed: {
    ...mapGetters("links", [
      "categories",
      "subCategories",
      "typesCategories",
      "typesSubCategories"
    ]),
    ...mapGetters("app", ["resolveUser"]),
    ...mapState("app", ["users_list"])
  },
  methods: {
    ...mapActions("links", [
      "loadCategories",
      "loadSubCategories",
      "updateCategories",
      "updateSubCategories",
      "setCategory",
      "setSubCategory",
      "removeElement",
      "setUserAccess",
      "removeUserAccess"
    ]),
    ...mapActions("app", ["getUsersList"]),
    userName(email) {
      try {
        const { first_name, last_name } = this.resolveUser(email);
        if (first_name && last_name) {
          return `${first_name} ${last_name}`;
        } else {
          return email;
        }
      } catch (e) {
        void e;
        return email;
      }
    },
    filteredUserList() {
      return this.users_list.filter(item => item.access);
    },
    getDataItem(data) {
      this.itemId = data.id;
      this.selectedItem = data.text;
    },
    getDataForRemove(data) {
      this.itemId = data.id;
      this.titleItem = data.title;
    },
    reset(name) {
      this.itemId = null;
      this.titleItem = null;
      this.selectedItem = null;
      this.selectedUser = null;
      this.attach = false;
      this.$bvModal.hide(name);
    },
    remove() {
      if (this.titleItem === "user") {
        this.removeUserAccess({ email: this.itemId });
      } else {
        this.removeElement({
          id: this.itemId,
          name: this.titleItem
        });
      }
      this.$bvModal.hide("delete");
    },
    editCategory() {
      this.updateCategories({
        id: this.itemId,
        text: this.selectedItem.text
          ? this.selectedItem.text
          : this.selectedItem,
        attach: this.attach
      });
      this.reset("edit-category");
    },
    editSubCategory() {
      this.updateSubCategories({
        id: this.itemId,
        text: this.selectedItem.text
          ? this.selectedItem.text
          : this.selectedItem
      });
      this.reset("edit-subcategory");
    },
    addCategory() {
      const id =
        this.categories.length > 0
          ? this.categories[this.categories.length - 1].id + 1
          : 1;
      this.setCategory({
        id: id,
        text: this.selectedItem,
        attach: this.attach
      });
      this.reset("new-category");
    },
    addSubCategory() {
      const id =
        this.subCategories.length > 0
          ? this.subCategories[this.subCategories.length - 1].id + 1
          : 1;
      this.setSubCategory({
        id: id,
        text: this.selectedItem
      });
      this.reset("new-subcategory");
    },
    getAccess() {
      this.setUserAccess({ email: this.selectedUser.email });
      this.reset("get-access");
    }
  },
  watch: {
    users_list(val) {
      if (val) {
        this.users_list.some(user => {
          if (!user.access) {
            const obj = {
              text: this.userName(user.email),
              email: user.email
            };
            this.filteredUserName.push(obj);
          }
        });
      }
    }
  }
};
</script>
